export default __webpack_public_path__ + "static/media/PTSerif-Italic.d90ee47f.ttf";